/** Mockup 01-A · Preparar — só os selects com MAIS de uma opção (D15). */
import type { LeadCaptureOptionsResponse } from '@troia-v3/types';
import React from 'react';

import { Button, ModalContent, ModalFooter, Select } from '@/shared/components/ui';

import { CaptureInfoBox } from './captureUi';

export interface CapturePrepareValue { funnelId: string; teamId?: string; unitId?: string }

export interface CapturePrepareStepProps {
  options: LeadCaptureOptionsResponse;
  value: CapturePrepareValue;
  onChange: (next: CapturePrepareValue) => void;
  onCancel: () => void;
  onGenerate: () => void;
  generating: boolean;
}

export const CapturePrepareStep: React.FC<CapturePrepareStepProps> = ({ options, value, onChange, onCancel, onGenerate, generating }) => (
  <>
    <ModalContent>
      {options.funnels.length > 1 && (
        <div className="mb-3.5">
          <Select
            label="Funil"
            options={options.funnels.map((f) => ({ value: f.id, label: f.name }))}
            value={value.funnelId}
            onChange={(funnelId) => onChange({ ...value, funnelId })}
            fullWidth
            data-testid="capture-prepare-funnel"
          />
          <div className="text-xs mt-1.5" style={{ color: '#64748b' }}>O lead entra na primeira etapa deste funil, já com você como responsável.</div>
        </div>
      )}
      {options.teams.length > 1 && (
        <div className="mb-3.5">
          <Select
            label="Equipe"
            options={options.teams.map((t) => ({ value: t.id, label: t.name }))}
            value={value.teamId ?? ''}
            onChange={(teamId) => onChange({ ...value, teamId })}
            fullWidth
            data-testid="capture-prepare-team"
          />
        </div>
      )}
      {options.units.length > 1 && (
        <div>
          <Select
            label="Unidade"
            options={options.units.map((u) => ({ value: u.id, label: u.name }))}
            value={value.unitId ?? ''}
            onChange={(unitId) => onChange({ ...value, unitId })}
            fullWidth
            data-testid="capture-prepare-unit"
          />
          <div className="text-xs mt-1.5" style={{ color: '#64748b' }}>Vai junto no lead e conta no ranking da loja.</div>
        </div>
      )}
      <CaptureInfoBox tone="slate" icon="info" className="mt-3.5">
        Só perguntamos o que tem mais de uma opção. Se você estivesse em uma única equipe ou unidade, ela seria usada automaticamente e o QR apareceria direto.
      </CaptureInfoBox>
    </ModalContent>
    <ModalFooter>
      <Button variant="ghost" onClick={onCancel} data-testid="capture-prepare-cancel">Cancelar</Button>
      <span className="flex-1" />
      <Button variant="primary" icon="arrow-right" iconPosition="right" loading={generating} disabled={!value.funnelId} onClick={onGenerate} data-testid="capture-prepare-generate">
        Gerar QR Code
      </Button>
    </ModalFooter>
  </>
);
